(function() {
  ACC.osCheckout = {
    formFieldInputClass: '.form_field-input',
    formFieldErrorClass: 'ph-form_field_error',
    formFieldSuccessClass: 'ph-form_field_success',
    spinner: 'ph-spinnerorder',
    formContactNameNumberFormClass: '.ph-onestorecheckout_contactinfo>.form_field-container',
    salesOrgAttribute: 'data-salesorg',
    deliveryModeRDDClass: '.ph-deliveryMode--rdd',
    checkValidation: '.ph-checkValidation',
    inputBoxCheckBox: 'input[type=checkbox]',
    paymentPayeeValidation: false,
    paymentBillingValidation: false,
    paymentPageCheckboxValidation: false,
    paymentTypeValidation: false,
    inBillingNoAddress: '.inbilling.ph-noaddress_section',
    inPayeeNoAddress: '.inpayee.ph-noaddress_section',
    billingButton: 'billingButton',
    payeeButton: 'payeeButton',
    button: 'button',
    billingAddressCheck: '.ph-ch_payment-addr_billing',
    payeeAddressCheck: '.ph-ch_payment-addr_payee',
    rddValidationMsgClass: '.ph-checkout__rddValidationMsg',
    onestoreb2bsections: '.ph-onestore_b2bsections',
    finalRequestDate: 'finalRequestDate',

    copyContactNameNumber: function(currentTag, currentValue) {
      $(ACC.osCheckout.formContactNameNumberFormClass).find('input').each(function() {
        var fieldName = this.name.split('_')[0];

        if (fieldName === currentTag && this.value === '') {
          this.value = currentValue;
          ACC.osCheckout.osSetContactInfoAjax(this, currentValue);
        }
      });
    },

    bindContactNameNumberEvents: function() {
      $(ACC.osCheckout.formContactNameNumberFormClass).find('input').on('keyup', function() {
        if (this.name.split('_')[0] === 'contactPhone') {
          ACC.address.validatePhoneNumber();
        }
      });
      $(ACC.osCheckout.formContactNameNumberFormClass).find('input').on('change', function() {
        var currentTag = this.name.split('_')[0];
        var currentValue = this.value;

        ACC.osCheckout.osSetContactInfoAjax(this, currentValue);
        ACC.osCheckout.copyContactNameNumber(currentTag, currentValue);
      });
    },

    osSetContactInfoAjax: function(tagDiv, value) {
      var tag = tagDiv.name.split('_')[0],
          salesOrg = tagDiv.name.split('_')[1],
          ajaxUrl = '',
          ajaxData = {};

      if (tag === 'contactName') {
        ajaxUrl = $('.ph-setAttentionNameURL').text();
        ajaxData = {
          deliveryAttention: value,
          salesOrg: salesOrg
        };
      } else if (tag === 'contactPhone') {
        ajaxUrl = $('.ph-setAttentionPhoneURL').text();
        ajaxData = {
          deliveryPhone: value,
          salesOrg: salesOrg
        };
      } else if (tag === 'spsDeliveryInstruction') {
        ajaxUrl = $('.ph-setInstructionURL').text();
        ajaxData = {
          spsDeliveryInstruction: value,
          salesOrg: salesOrg
        };
      }

      if (ajaxUrl && ajaxData.salesOrg) {
        $.postJSON(ACC.config.contextPath + ajaxUrl, ajaxData);
      }
    },

    bindOneStoreOtaDomEvents: function() {
      $('#addtoaddressbook').on('click', function() {
        $('.ph-addtoaddressbook__notcheckedmsg, .ph-addtoaddressbook__checkedmsg').toggle();
      });

      $('#country').on('change', function() {
        $('.' + ACC.osCheckout.spinner).removeClass('hidden');

        var countryValue = $(this).val(),
            countryPath = $(this).attr('data-url');

        if (countryValue !== '') {
          $.ajax({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json; charset=utf-8'
            },
            url: ACC.config.contextPath + countryPath,
            type: 'GET',
            data: {
              country: countryValue
            },
            dataType: 'json',
            success: function(result) {
              $('#region').empty();
              ACC.osCheckout.loadRegionDeliveryModes(result);

              $('#region').selectBox('refresh');
              $('.' + ACC.osCheckout.spinner).addClass('hidden');
            }
          });
        }
      });
    },

    loadRegionDeliveryModes: function(result) {
      if (result && result.regionDatas) {
        $.each(result.regionDatas, function(k, v) {
          $('#region').append('<option isocodeshort="' + v.isocodeShort + '"  value="' + v.isocode + '">' + v.name + '</option>');
        });
      }

      if (result && result.oneStoreDeliveryModes) {
        var oneStoreDeliveryModes = result.oneStoreDeliveryModes;

        for (var salesOrg in oneStoreDeliveryModes) {
          if (oneStoreDeliveryModes[salesOrg] && oneStoreDeliveryModes[salesOrg].length > 0) {
            ACC.osCheckout.loadDeliveryModes(oneStoreDeliveryModes[salesOrg], salesOrg);
          }
        }
      }
    },

    viewMoreProducts: function(elem, mode) {
      var onestoreAccount = elem.parents(ACC.osCheckout.onestoreb2bsections);

      if (mode === 'more') {
        onestoreAccount.find('.ph-notvisible').removeClass('hidden');
        elem.addClass('hidden');
        onestoreAccount.find('.ph-seeless_button').removeClass('hidden');
      } else {
        onestoreAccount.find('.ph-notvisible').addClass('hidden');
        onestoreAccount.find('.ph-seemore_button').removeClass('hidden');
        elem.addClass('hidden');
      }
    },

    oneTimeAddressValidation: function(showError) {
      var validationStatus = true;

      $('.ph-onestore_onetimeaddress_form input:not(#houseNumber, #addressLine2), .ph-onestore_onetimeaddress_form select').each(function() {
        var fieldValue = $(this).val();

        if (fieldValue && $.trim(fieldValue) !== '') {
          $(this).parent(ACC.osCheckout.formFieldInputClass).addClass(ACC.osCheckout.formFieldSuccessClass);
          $(this).parent(ACC.osCheckout.formFieldInputClass).removeClass(ACC.osCheckout.formFieldErrorClass);

          if (ACC.osCheckout.isInvalidInput($(this))) {
            validationStatus = false;
          }
        } else {
          $(this).parent(ACC.osCheckout.formFieldInputClass).removeClass(ACC.osCheckout.formFieldSuccessClass)
            .removeClass('ph-invalidinput__error');
          validationStatus = false;

          if (showError) {
            $(this).parent(ACC.osCheckout.formFieldInputClass).addClass(ACC.osCheckout.formFieldErrorClass);
          }
        }
      });

      return validationStatus;
    },

    isInvalidInput: function(fieldElem) {
      var isInvalid = false,
          invalidinputClass = 'ph-invalidinput__error';

      if (fieldElem.hasClass('validate_postcode') && ACC.validation.postalCode(fieldElem.val(), '#country')) {
        fieldElem.parent(ACC.osCheckout.formFieldInputClass).addClass(ACC.osCheckout.formFieldErrorClass)
          .addClass(invalidinputClass);
        fieldElem.parent(ACC.osCheckout.formFieldInputClass).removeClass(ACC.osCheckout.formFieldSuccessClass);
        isInvalid = true;
      } else {
        fieldElem.parent(ACC.osCheckout.formFieldInputClass).removeClass(ACC.osCheckout.formFieldErrorClass)
          .removeClass(invalidinputClass);
        fieldElem.parent(ACC.osCheckout.formFieldInputClass).addClass(ACC.osCheckout.formFieldSuccessClass);
      }

      return isInvalid;
    },

    bindOtaDomEvents: function() {
      $('#onetimeaddress_checkbox').on('click', function() {
        var $onestoreOnetimeAddressArea = $('.ph-onestore_onetimeaddress'),
            $onestoreOnetimeAddressInfo = $('.ph-ota-address__info');

        if ($(this).is(':checked')) {
          $onestoreOnetimeAddressArea.show();
          $onestoreOnetimeAddressArea.find('#country').trigger('blur');

          if (ACC.osCheckout.oneTimeAddressValidation(false)) {
            ACC.osCheckout.otaFilledSuccess();
          } else {
            $onestoreOnetimeAddressInfo.show().html($('.otaPlaceholderMsg').html());
          }

          $('.ph-shipping_otatoggle').hide();
          $('.ph-selectshippingaddress__errormsg--main').addClass('hidden');
        } else {
          $onestoreOnetimeAddressArea.hide();
          $onestoreOnetimeAddressInfo.hide();

          $('.ph-shipping_otatoggle').show();
          ACC.osAddress.getAtpOnPageload(true);
          ACC.osAddress.handleShippingAddressErrorHidden();
          ACC.osAddress.handleShippingAddressErrorVisible();
        }
      });

      $('.ph-onestore_onetimeaddress_form input, .ph-onestore_onetimeaddress_form select').on('blur', function() {
        var fieldValue = $(this).val();

        if (fieldValue && $.trim(fieldValue) !== '') {
          $(this).parent(ACC.osCheckout.formFieldInputClass).removeClass(ACC.osCheckout.formFieldErrorClass);
        } else {
          $(this).parent(ACC.osCheckout.formFieldInputClass).addClass(ACC.osCheckout.formFieldErrorClass);
        }

        if (ACC.osCheckout.oneTimeAddressValidation(false)) {
          ACC.osCheckout.otaFilledSuccess();
        }
      });

      ACC.osCheckout.oneTimeHouseStreetBlurFunction();

      if (ACC.osCheckout.isOneTimeAddress()) {
        $('#allowDropShip').show();
        ACC.osCheckout.prefillOTAForm();
      }
    },

    oneTimeHouseStreetBlurFunction: function() {
      $('.ph-onestore_onetimeaddress_form input#houseNumber, .ph-onestore_onetimeaddress_form input#addressLine2').on('blur', function() {
        if ($(this).val()) {
          $(this).parent('.ph-formfieldInputMain').addClass(ACC.osCheckout.formFieldSuccessClass);
        } else {
          $(this).parent('.ph-formfieldInputMain').removeClass(ACC.osCheckout.formFieldSuccessClass);
        }
      });
    },

    otaFilledSuccess: function() {
      var addtoaddressbook = 'false',
          $dropshipField = $('.ph-onestore_onetimeaddress_form');

      if ($dropshipField.find('#addtoaddressbook').prop('checked')) {
        addtoaddressbook = 'true';
      }

      var addressData = {
        firstName: $dropshipField.find('.ph-forminput[name=firstName]').val(),
        houseno: $dropshipField.find('.ph-forminput[name=apartment]').val(),
        line1: $dropshipField.find('.ph-forminput[name=line1]').val(),
        line2: $dropshipField.find('.ph-forminput[name=line2]').val(),
        townCity: $dropshipField.find('.ph-forminput[name=townCity]').val(),
        country: $dropshipField.find('.ph-forminput[name=country]').val(),
        regionIso: $dropshipField.find('.ph-forminput[name=regionIso]').val(),
        postcode: $dropshipField.find('.ph-forminput[name=postcode]').val(),
        addtoaddressbook: addtoaddressbook
      };

      ACC.osCheckout.loadOtaShippingTemplate(addressData, '.ph-ota-address__info', true);
      ACC.osCheckout.getAtpInfoForOta(addressData);
    },

    loadOtaShippingTemplate: function(addressInfo, addressElement, formData) {
      if (formData) {
        var $isocodeShortField = $('#region>option:selected'),
            isocodeShort = $isocodeShortField.text();

        if (isocodeShort && isNaN(parseInt($isocodeShortField.attr('isocodeshort'), 10))) {
          isocodeShort = $isocodeShortField.attr('isocodeshort');
        }

        addressInfo.companyName = addressInfo.firstName;
        addressInfo.apartment = addressInfo.houseno;
        addressInfo.town = addressInfo.townCity;
        addressInfo.region = {
          regionIso: addressInfo.regionIso,
          isocodeShort: isocodeShort
        };
        addressInfo.postalCode = addressInfo.postcode;

        if ($('.ph-checkout_selected_address').attr('iseuaddressformat') === 'true') {
          addressInfo.europeanAddressFormat = true;
        } else {
          addressInfo.europeanAddressFormat = false;
        }

        $('.ph-default-address__info').hide();
        $('.ph-addressselection-buttonitem').hide();
      }

      $(addressElement).show().html($('#addressTemplate').tmpl({
        address: addressInfo,
        displayCodeRegionIso: $('.displayCodeRegionIso').text()
      }));
    },

    loadDeliveryModes: function(deliveryModes, salesOrg) {
      var $deliveryModeElem = $('#deliveryModes_' + salesOrg),
          showDeliveryCost = false,
          dmRadioInputClass = 'ph-deliverymethod-radio',
          selectedDeliveryModeId = false;

      if ($('.showDeliveryCostForCountry').html().toLowerCase() === 'true') {
        showDeliveryCost = true;
      }

      if ($deliveryModeElem.find('.' + dmRadioInputClass + ':checked').length > 0) {
        selectedDeliveryModeId = $deliveryModeElem.find('.' + dmRadioInputClass + ':checked').attr('id');
      }

      $deliveryModeElem.html($('#deliveryModesTemplate').tmpl({
        deliveryModes: deliveryModes,
        salesOrg: salesOrg,
        shippingModeTitle: $('.shippingModeTitle').html(),
        showDeliveryCostForCountry: showDeliveryCost,
        rddSalesOrg: '02_RDD_' + salesOrg
      }));

      ACC.osCheckout.onClickRDDDatePicker();
      ACC.osCheckout.onLoadRDDDatePicker();
      ACC.osCheckout.onChangeDeliveryMethodFunctions();

      if ($deliveryModeElem.find('.' + dmRadioInputClass + ':checked').length <= 0) {
        if ($deliveryModeElem.find('.' + dmRadioInputClass).length === 1) {
          $deliveryModeElem.find('.' + dmRadioInputClass).prop('checked', true);
        } else if (selectedDeliveryModeId && $deliveryModeElem.find('#' + selectedDeliveryModeId).length > 0) {
          $deliveryModeElem.find('#' + selectedDeliveryModeId).prop('checked', true);
        } else if ($deliveryModeElem.find('#dm_02_' + salesOrg).length > 0) {
          $deliveryModeElem.find('#dm_02_' + salesOrg).prop('checked', true);
        } else if ($deliveryModeElem.find('#dm_02_RDD' + salesOrg).length > 0) {
          $deliveryModeElem.find('#dm_02_RDD' + salesOrg).prop('checked', true);
        } else {
          $deliveryModeElem.find('.' + dmRadioInputClass).first().prop('checked', true);
        }
      }
    },

    setScrollTo: function(scrollValue, newScrollValue) {
      var returnScrollValue = scrollValue;

      if (scrollValue === 0) {
        returnScrollValue = newScrollValue;
      }

      return returnScrollValue;
    },

    getAtpInfoForOta: function(addressData) {
      var getStockforOtaUrl = $('.ph-getStockforOtaUrl').html();

      addressData.region = '';
      $.ajax({
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json; charset=utf-8'
        },
        url: ACC.config.contextPath + getStockforOtaUrl,
        type: 'POST',
        data: JSON.stringify(addressData),
        dataType: 'json',
        success: function(result) {
          if (result && result.salesAreaATPData) {
            var salesAreaAtpResponse = result.salesAreaATPData,
                updateEntries = false;

            if (result.updateEntries === true) {
              updateEntries = true;
            }

            salesAreaAtpResponse.forEach(function(salesAreaATPData) {
              salesAreaATPData.updateEntries = updateEntries;

              if (salesAreaATPData.salesOrgType !== 'src') {
                ACC.osAddress.showAtpfromResponse(salesAreaATPData, salesAreaATPData.salesOrg);
              }
            });
          }
        }
      });
    },

    isOneTimeAddress: function() {
      var oneTimeAddress = false;

      if ($('.allowDropShip').html() === 'true' && $('.srcTypeAvailable').html() !== 'true') {
        oneTimeAddress = true;
      }

      return oneTimeAddress;
    },

    prefillOTAForm: function() {
      var $addressItemElem = $('.inshipping'),
          otaObject = {};

      if ($addressItemElem.attr('isonetimeaddress') === 'true') {
        otaObject.compName = $.trim($addressItemElem.find('.compName').first().text());
        otaObject.houseno = $.trim($addressItemElem.find('.houseno').first().text());
        otaObject.line1 = $.trim($addressItemElem.find('.line1').first().text());
        otaObject.line2 = $.trim($addressItemElem.find('.line2').first().text());
        otaObject.city = $.trim($addressItemElem.find('.city').first().text());
        otaObject.isocode = $.trim($addressItemElem.find('.isocode').first().text());
        otaObject.pcode = $.trim($addressItemElem.find('.pcode').first().text());

        ACC.osCheckout.setOTAFormData(otaObject);

        setTimeout(function() {
          $('#onetimeaddress_checkbox').trigger('click');
        }, 1000);
        ACC.osCheckout.oneTimeAddressValidation(false);
      }
    },

    setOTAFormData: function(otaObject) {
      var $formElem = $('.ph-onestore_onetimeaddress_form');

      $formElem.find('input#name').val(otaObject.compName);
      $formElem.find('input#houseNumber').val(otaObject.houseno);
      $formElem.find('input#addressLine1').val(otaObject.line1);
      $formElem.find('input#addressLine2').val(otaObject.line2);
      $formElem.find('input#city').val(otaObject.city);
      $formElem.find('select#region').val(otaObject.isocode);
      $formElem.find('input#postCode').val(otaObject.pcode);
    },

    otaCheckedAndUnchecked: function() {
      var otaCheckedUncheckedObj = {
        compName: '',
        houseno: '',
        line1: '',
        line2: '',
        city: '',
        isocode: '',
        pcode: ''
      };

      ACC.osCheckout.setOTAFormData(otaCheckedUncheckedObj);
    },

    rddDateSelectionValidation: function(currentThis, scrollValue, validated) {
      var isRddChecked = currentThis.find('.ph-deliveryMode--rdd:checked').length > 0,
          $currentRdd = currentThis.find(ACC.osCheckout.deliveryModeRDDClass),
          salesOrg = $currentRdd.attr(ACC.osCheckout.salesOrgAttribute),
          $currentRddParent = currentThis.parents(ACC.osCheckout.onestoreb2bsections),
          isRddDateSelected = $currentRddParent.find('#requestedDeliveryDate_' + salesOrg).val(),
          rddDateValidationObj = {
            scrollValueFinal: scrollValue,
            validatedFinal: validated
          };

      if (isRddChecked) {
        if (isRddDateSelected) {
          $currentRddParent.find('.ph-partdelivery input[name=completeDelivery_' + salesOrg + ']').prop('checked', true);
        } else {
          currentThis.find(ACC.osCheckout.rddValidationMsgClass).removeClass('hidden');
          rddDateValidationObj.scrollValueFinal = ACC.osCheckout.setScrollTo(scrollValue, $currentRdd.offset().top - 100);
          rddDateValidationObj.validatedFinal = false;
        }
      }

      return rddDateValidationObj;
    },

    validateShippingPage: function() {
      var validated = true,
          scrollValue = 0;

      if (ACC.osCheckout.isOneTimeAddress() && $('.ph-onetimeaddress_checkbox').is(':checked')) {
        if (ACC.osCheckout.oneTimeAddressValidation(true) === false) {
          validated = false;
          scrollValue = ACC.osCheckout.setScrollTo(scrollValue, 10);
        }
      } else {
        ACC.osCheckout.otaCheckedAndUnchecked();

        if ($('.ph-noaddress_section').is(':visible')) {
          validated = false;
          $('.ph-selectshippingaddress__errormsg--main').removeClass('hidden');
        }
      }

      $('.ph-deliverymodes').each(function() {
        if ($(this).find('.ph-deliverymethod-radio:checked').length <= 0) {
          validated = false;
          $(this).find('.ph-os__deliverymode--errormsg').show();
          scrollValue = ACC.osCheckout.setScrollTo(scrollValue, $(this).offset().top);
        }

        var rddDateValidationObject = ACC.osCheckout.rddDateSelectionValidation($(this), scrollValue, validated);

        scrollValue = rddDateValidationObject.scrollValueFinal;
        validated = rddDateValidationObject.validatedFinal;
      });

      if (validated) {
        $('.' + ACC.osCheckout.spinner).removeClass('hidden');
        $('#onestoreCheckoutAddressForm').submit();

        setTimeout(function() {
          $('.ph-spinnerorder').addClass('hidden');
        }, 25000);

        if (window.tempEvent && window.tempEvent.length > 0) {
          window.tempEvent.forEach(function(elem) {
            window.eddlEvents.push(elem);
          });
          window.tempEvent = [];
        }
      } else {
        $('html, body').animate({
          scrollTop: scrollValue
        }, 'slow');
      }
    },

    onClickRDDDatePicker: function() {
      $('input.ph-deliveryMode--rdd[type="radio"]').on('click', function() {
        var endDateDays = 365,
            endDateDaysString = $(this).parents('.ph-onestore_b2bsections').find('.ph-rdd__endDate').text();

        if (parseInt(endDateDaysString, 10) > 0) {
          endDateDays = parseInt(endDateDaysString, 10);
        }

        var minDateValue = new Date($(this).parents('.ph-onestore_b2bsections').find('.ph-rdd__startDate').html()),
            maxDateValue = new Date(minDateValue.getFullYear(), minDateValue.getMonth(), minDateValue.getDate() + endDateDays);

        $(this).datepicker('option', 'minDate', minDateValue);
        $(this).datepicker('option', 'maxDate', maxDateValue);
        $(this).parent().find('input.hasDatepicker').datepicker('show');
      });
    },

    rddDateFormatForYear: function(receivedRddDateFormat) {
      var rddDateFormat = receivedRddDateFormat;

      if (rddDateFormat.includes('YYYY') || rddDateFormat.includes('YYY') || rddDateFormat.includes('yyyy') || rddDateFormat.includes('yyy')) {
        rddDateFormat = rddDateFormat.replace(/YYYY|YYY|yyyy|yyy/, 'yy');
      } else if (rddDateFormat.includes('YY') || rddDateFormat.includes('yy')) {
        rddDateFormat = rddDateFormat.replace(/YY|yy/, 'y');
      } else if (rddDateFormat.includes('Y') || rddDateFormat.includes('y')) {
        rddDateFormat = rddDateFormat.replace(/Y|y/, 'yy');
      }

      return rddDateFormat;
    },

    rddDateFormatForMonth: function(receivedRddDateFormat) {
      var rddDateFormat = receivedRddDateFormat;

      if (rddDateFormat.includes('MMMM') || rddDateFormat.includes('MMM')) {
        rddDateFormat = rddDateFormat.replace(/MMMM/, 'MM');
        rddDateFormat = rddDateFormat.replace(/MMM/, 'M');
      } else if (rddDateFormat.includes('mmmm') || rddDateFormat.includes('mmm')) {
        rddDateFormat = rddDateFormat.replace(/mmmm|mmm/, 'mm');
      } else if (rddDateFormat.includes('MM') || rddDateFormat.includes('M')) {
        rddDateFormat = rddDateFormat.replace(/MM|M/, 'mm');
      }

      rddDateFormat = ACC.osCheckout.rddDateFormatForYear(rddDateFormat);

      return rddDateFormat;
    },

    rddDateFormatForDay: function(receivedRddDateFormat) {
      var rddDateFormat = receivedRddDateFormat;

      if (rddDateFormat.includes('DDDD') || rddDateFormat.includes('DDD') || rddDateFormat.includes('dddd') || rddDateFormat.includes('ddd')) {
        rddDateFormat = rddDateFormat.replace(/DDDD|DDD|dddd|ddd/, 'dd');
      } else if (rddDateFormat.includes('DD') || rddDateFormat.includes('dd')) {
        rddDateFormat = rddDateFormat.replace(/DD|dd/, 'dd');
      } else if (rddDateFormat.includes('D') || rddDateFormat.includes('d')) {
        rddDateFormat = rddDateFormat.replace(/D|d/, 'dd');
      }

      rddDateFormat = ACC.osCheckout.rddDateFormatForMonth(rddDateFormat);

      return rddDateFormat;
    },
    rddSelectionOosDisplay: function($this) {
      var atpOutofStockDiv = $this.parents(ACC.osCheckout.onestoreb2bsections).find('.ph-os_cartitem_atpoutofstock.shown');

      if (atpOutofStockDiv.length > 0) {
        atpOutofStockDiv.each(function() {
          var $atpOutofStockDivItem = $(this);

          if ($atpOutofStockDivItem.length > 0 && $atpOutofStockDivItem.parent().find('.ph-atpqty-display').length === 0) {
            $atpOutofStockDivItem.siblings('.ph-os_cartitem_outofstock').removeClass('hidden');
          }
        });
      }
    },
    removeRddSelection: function($this) {
      if (!$this.hasClass('ph-deliveryMode--rdd')) {
        $this.parents(ACC.osCheckout.onestoreb2bsections).find('.ph-os_cartitem_outofstock').addClass('hidden');
        $this.parents(ACC.osCheckout.onestoreb2bsections).find('.ph-os_cartitem_atpoutofstock.shown').removeClass('hidden');
        $this.parents(ACC.osCheckout.onestoreb2bsections).find('.ph-os_cartitem_atpinstock.shown').removeClass('hidden');
        $this.parents(ACC.osCheckout.onestoreb2bsections).find('.ph-os_cartitem_outofstock.shown').removeClass('hidden');
        $this.parents(ACC.osCheckout.onestoreb2bsections).find('.ph-os_cartitem_rdd').addClass('hidden');
        $('#requestedDeliveryDate_' + $this.attr(ACC.osCheckout.salesOrgAttribute)).val('');
        sessionStorage.removeItem(ACC.osCheckout.finalRequestDate + '_' + $this.attr(ACC.osCheckout.salesOrgAttribute));
      }
    },
    onLoadRDDDatePicker: function() {
      var rddDateFormat = $('.ph-rdd__dateFormat').html();

      rddDateFormat = ACC.osCheckout.rddDateFormatForDay(rddDateFormat);

      $(ACC.osCheckout.deliveryModeRDDClass).datepicker({
        beforeShowDay: $.datepicker.noWeekends,
        onSelect: function() {
          var requestedDate = $(this).datepicker('getDate'),
              finalRequestDate = $.datepicker.formatDate(rddDateFormat, requestedDate),
              deliveryCodeVal = $(this).attr('data-delivery-code'),
              salesOrg = $(this).attr(ACC.osCheckout.salesOrgAttribute),
              $currentRddParent = $(this).parents(ACC.osCheckout.onestoreb2bsections);

          $currentRddParent.find(ACC.osCheckout.rddValidationMsgClass).addClass('hidden');
          $(this).parents(ACC.osCheckout.onestoreb2bsections).find('.ph-checkout_rdddeliveryDate').html(finalRequestDate);
          $currentRddParent.find('#requestedDeliveryDate_' + salesOrg).val(finalRequestDate);
          $(this).val(deliveryCodeVal);
          $(this).parents(ACC.osCheckout.onestoreb2bsections).find('.ph-os_cartitem_atpinstock').addClass('hidden');
          $(this).parents(ACC.osCheckout.onestoreb2bsections).find('.ph-os_cartitem_atpoutofstock').addClass('hidden');
          $(this).parents(ACC.osCheckout.onestoreb2bsections).find('.ph-os_cartitem_atpinstock.shown').siblings('.ph-os_cartitem_rdd').removeClass('hidden');
          ACC.osCheckout.rddSelectionOosDisplay($(this));
          sessionStorage.setItem(ACC.osCheckout.finalRequestDate + '_' + salesOrg, finalRequestDate);
          $(this).blur();
        }
      });
    },

    onLoadDeliveryPreference: function() {
      $('.ph-deliverymethod-radio:checked').each(function() {
        var salesOrg = $(this).attr(ACC.osCheckout.salesOrgAttribute),
            currentSelection = $(this).attr('data-delivery-code');

        ACC.osCheckout.hideShowDeliveryPreference(currentSelection, salesOrg, $(this));
      });
    },

    hideShowDeliveryPreference: function(currentSelection, salesOrg, currentThis) {
      var $currentRddParent = currentThis.parents(ACC.osCheckout.onestoreb2bsections),
          $currentDeliveryPreference = $currentRddParent.find('.ph-delivery-pref__title, #deliveryPref_' + salesOrg),
          currentDeliveryPreferenceFlag = $currentRddParent.find('.ph-deliveryPreferenceVisibility__' + salesOrg).html();

      if (currentSelection === '02_RDD_' + salesOrg) {
        $currentDeliveryPreference.addClass('ph-d-none');
        $('#requestedDeliveryDate_' + salesOrg).prop('disabled', false);
      } else {
        $currentRddParent.find(ACC.osCheckout.rddValidationMsgClass).addClass('hidden');
        $currentDeliveryPreference.removeClass('ph-d-none hidden');
        $('#requestedDeliveryDate_' + salesOrg).prop('disabled', true);
      }

      if (currentDeliveryPreferenceFlag && $currentDeliveryPreference.is(':visible')) {
        $currentDeliveryPreference.addClass('hidden');
      }
    },

    hideShowDeliveryPreferenceMain: function(currentThis) {
      var salesOrg = currentThis.attr(ACC.osCheckout.salesOrgAttribute),
          currentSelection = currentThis.attr('data-delivery-code');

      ACC.osCheckout.hideShowDeliveryPreference(currentSelection, salesOrg, currentThis);
    },

    displayRddAtpMessage: function() {
      $(ACC.osCheckout.onestoreb2bsections).each(function() {
        if ($(this).find('.ph-deliveryMode--rdd:checked').length > 0) {
          $(this).find('.ph-rddAtp_message').removeClass('hidden');
          $(this).find('.ph-atp_deliveryMsg').addClass('hidden');
        } else {
          $(this).find('.ph-rddAtp_message').addClass('hidden');
          $(this).find('.ph-atp_deliveryMsg').removeClass('hidden');
        }
      });
    },

    onChangeDeliveryMethodFunctions: function() {
      $('input.ph-deliverymethod-radio[type="radio"]').on('change', function() {
        ACC.osCheckout.displayRddAtpMessage();
        ACC.osCheckout.hideShowDeliveryPreferenceMain($(this));
        ACC.osCheckout.removeRddSelection($(this));
      });
    },
    paymentPageValidationFunction: function() {
      $('.ph-ch_payment_addr').each(function() {
        if ($(this).find(ACC.osCheckout.inBillingNoAddress).hasClass('ph-d-none') === false) {
          $(this).find(ACC.osCheckout.inBillingNoAddress + ' ' + ACC.osCheckout.button).addClass(ACC.osCheckout.billingButton);
        } else {
          $(this).find(ACC.osCheckout.inBillingNoAddress + ' ' + ACC.osCheckout.button).removeClass(ACC.osCheckout.billingButton);
        }

        if ($(this).find(ACC.osCheckout.inPayeeNoAddress).hasClass('ph-d-none') === false) {
          $(this).find(ACC.osCheckout.inPayeeNoAddress + ' ' + ACC.osCheckout.button).addClass(ACC.osCheckout.payeeButton);
        } else {
          $(this).find(ACC.osCheckout.inPayeeNoAddress + ' ' + ACC.osCheckout.button).removeClass(ACC.osCheckout.payeeButton);
        }
      });

      if ($('.' + ACC.osCheckout.billingButton).length > 0) {
        ACC.osCheckout.paymentBillingValidation = false;
        $('.ph-billingAddressError').removeClass('hiddenClass');
      } else {
        ACC.osCheckout.paymentBillingValidation = true;
        $('.ph-billingAddressError').addClass('hiddenClass');
      }


      if ($('.' + ACC.osCheckout.payeeButton).length > 0) {
        ACC.osCheckout.paymentPayeeValidation = false;
        $('.ph-payeeAddressError').removeClass('hiddenClass');
      } else {
        ACC.osCheckout.paymentPayeeValidation = true;
        $('.ph-payeeAddressError').addClass('hiddenClass');
      }

      if ($(ACC.osCheckout.payeeAddressCheck).length === 0 &&
          $(ACC.osCheckout.billingAddressCheck).length === 0) {
        ACC.osCheckout.paymentBillingValidation = true;
        ACC.osCheckout.paymentPayeeValidation = true;
      }

      ACC.osCheckout.termsAndConditionsCheckFunction();

      if (ACC.osCheckout.paymentBillingValidation === false ||
        ACC.osCheckout.paymentPayeeValidation === false) {
        $('html, body').animate({
          scrollTop: $('.ph-onestore_checkout').offset().top - 50
        }, 500);
      }
    },

    termsAndConditionsCheckFunction: function() {
      $('.terms').find(ACC.osCheckout.checkValidation).each(function() {
        if ($('.ph-checkValidation input[type=checkbox]:checkbox:checked').length === $('.ph-checkValidation input[type=checkbox]').length) {
          ACC.osCheckout.paymentPageCheckboxValidation = true;
        } else if (!$(this).find(ACC.osCheckout.inputBoxCheckBox).is(':checked')) {
          ACC.osCheckout.paymentPageCheckboxValidation = false;
          $(this).find('.ph-errorPayment').removeClass('hiddenClass');
        }
      });
    },

    paymentTypeCheck: function() {
      var checkoutnoPaymentError = '.ph-checkoutnoPaymentError';

      if ($(document).find('.ph-radiocontainer .ph-paymentmode:visible').length > 0) {
        ACC.osCheckout.paymentTypeValidation = true;
        $(document).find(checkoutnoPaymentError).hide();
      } else {
        ACC.osCheckout.paymentTypeValidation = false;
        $(document).find(checkoutnoPaymentError).show().removeClass('hiddenClass');
        $('html,body').animate({
          scrollTop: 0
        }, 'slow');
      }
    },

    onLoadCheckoutClickFunctions: function() {
      $('.ph-yourOrderdetails').on('click', function() {
        $('.ph-minicart').addClass('ph-onestorecheckout_cartinfo');
      });

      $('.ph-expandable_buttons').on('click', function() {
        ACC.osCheckout.viewMoreProducts($(this), $(this).attr('data-mode'));
      });

      $('.ph-deliverymodes').find('.ph-deliverymethod-radio').on('click', function() {
        $(this).parents('.ph-shipping-mode__fields').find('.ph-os__deliverymode--errormsg').hide();
      });

      ACC.osCheckout.onClickRDDDatePicker();

      ACC.osCheckout.onChangeDeliveryMethodFunctions();

      $('.ph-delivery-inst__label').on('click', function() {
        $(this).parents('.ph-deliveryaddress_div').find('.ph-delivery-instruction').toggle();
      });

      $('.spsDeliveryInstrText').on('change', function() {
        ACC.osCheckout.osSetContactInfoAjax(this, this.value);
      });

      $('#onestore_accountpayment').on('click', function() {
        ACC.osCheckout.paymentPageValidationFunction();
        ACC.osCheckout.paymentTypeCheck();

        var billingPayeecheck = false;

        if (ACC.osCheckout.paymentBillingValidation === true && ACC.osCheckout.paymentPayeeValidation === true && ACC.paymenttype.checkPONumberEmptyValue()) {
          billingPayeecheck = true;
        }

        if (billingPayeecheck === true &&
          ACC.osCheckout.paymentPageCheckboxValidation === true &&
          ACC.osCheckout.paymentTypeValidation === true) {
          $('#goldenOppnum').val(ACC.paymenttype.addGoldenOppurtunity());
          $(this).addClass('ph-clicked');
          $('.' + ACC.osCheckout.spinner).removeClass('hidden');
          $('#placeOrderForm1').submit();
        }
      });

      $('.ph-loggedIn_payNow').on('click', function() {
        ACC.osCheckout.termsAndConditionsCheckFunction();
        ACC.osCheckout.paymentTypeCheck();
        $('#goldenOppnum').val(ACC.paymenttype.addGoldenOppurtunity());

        if (ACC.osCheckout.paymentPageCheckboxValidation === true && ACC.osCheckout.paymentTypeValidation === true && ACC.paymenttype.checkPONumberEmptyValue()) {
          $('.ph-loggedIn_payNow').removeAttr('type').attr('type', 'submit');
          $('#termsFlag').val($('#Terms1').is(':checked'));
          $('#adendumFlag').val($('#lumifyAddendum1').is(':checked'));
          $('#aedadendumFlag').val($('#aedAddendum').is(':checked'));
          $('.' + ACC.osCheckout.spinner).removeClass('hidden');
          $('#paynowForm').submit();
        }
      });

      $('.terms').find(ACC.osCheckout.checkValidation).on('change', function() {
        $('.terms').find(ACC.osCheckout.checkValidation).each(function() {
          if ($(this).find(ACC.osCheckout.inputBoxCheckBox).is(':checked')) {
            $(this).find('.ph-errorPayment').addClass('hiddenClass');
          }
        });
      });

      $('.ph-shipping__procceed').on('click', function() {
        ACC.osCheckout.validateShippingPage();
      });
    },

    onLoadCheckoutFunctions: function() {
      ACC.osCheckout.onLoadCheckoutClickFunctions();

      if ($('.ph-checkout-shipping').length > 0) {
        ACC.osCheckout.onLoadRDDDatePicker();
        ACC.osCheckout.onLoadDeliveryPreference();
        ACC.osCheckout.displayRddAtpMessage();
        ACC.osCheckout.rebuildRdd();
      }

      ACC.osCheckout.bindOneStoreOtaDomEvents();
      ACC.osCheckout.bindOtaDomEvents();
      ACC.osCheckout.bindContactNameNumberEvents();
      $(document).on('input', '#goldenOppNumber', function() {
        this.value = this.value.replace(/\D/g, '');
      });
    },
    rebuildRdd: function() {
      $(ACC.osCheckout.onestoreb2bsections).each(function() {
        var $currentNode = $(this),
            currentRddNode = $currentNode.find('.ph-deliveryMode--rdd'),
            currentRddNodeChecked = currentRddNode.is(':checked'),
            salesOrg = $currentNode.attr('salesorg'),
            isErrorCase = $('.ph-checkout-global-message').find('.ph-information_message:visible').length,
            storedRddDate = sessionStorage.getItem(ACC.osCheckout.finalRequestDate + '_' + salesOrg);

        if (storedRddDate && isErrorCase > 0 && $currentNode.find('#dm_02_RDD_' + salesOrg).length > 0) {
          $currentNode.find('#dm_02_RDD_' + salesOrg).prop('checked', true);
          currentRddNodeChecked = true;
        }

        if (currentRddNodeChecked > 0 && storedRddDate) {
          var deliveryCodeVal = currentRddNode.attr('data-delivery-code'),
              $currentRddParent = currentRddNode.parents(ACC.osCheckout.onestoreb2bsections);

          $currentRddParent.find(ACC.osCheckout.rddValidationMsgClass).addClass('hidden');
          $currentNode.find('.ph-checkout_rdddeliveryDate').html(storedRddDate);
          $currentRddParent.find('#requestedDeliveryDate_' + salesOrg).val(storedRddDate);
          currentRddNode.val(deliveryCodeVal);
          $currentNode.find('.ph-os_cartitem_atpinstock').addClass('hidden');
          $currentNode.find('.ph-os_cartitem_atpoutofstock').addClass('hidden');
          $currentNode.find('.shown.ph-os_cartitem_atpinstock').siblings('.ph-os_cartitem_rdd').removeClass('hidden');
          ACC.osCheckout.rddSelectionOosDisplay(currentRddNode);
        }
      });
    }
  };

  $(document).on('ready', function() {
    if ($('.ph-onestore_checkout').length > 0) {
      $('.ph-spinnerorder').addClass('hidden');
      $('body').addClass('ph-onestore__main');

      ACC.osCheckout.onLoadCheckoutFunctions();
    } else {
      $('.ph-homepage__b2bUnitDesktop--salesOrg').each(function() {
        sessionStorage.removeItem(ACC.osCheckout.finalRequestDate + '_' + $(this).text());
      });
    }

    if ($('.paynowFormAction').length > 0) {
      $(document).on('submit', '.paynowFormAction', function() {
        $('#termsFlag').val($('#Terms1').is(':checked'));
        $('#adendumFlag').val($('#lumifyAddendum1').is(':checked'));
        $('.ph-spinnerorder').removeClass('hidden');
      });
    }
  });
})();

